import { TextBlock } from '../../../Atoms/Text';
import { ConfirmDialog } from '../ConfirmDialog';

export interface StepProgress {
  answered: number;
  required: number;
}

export interface LeaveStepDialogProps {
  open: boolean;
  stepName: string;
  destinationName: string;
  progress: StepProgress;
  onStay: () => void;
  onContinue: () => void;
}

export const LeaveStepDialog = ({
  open,
  stepName,
  destinationName,
  progress,
  onStay,
  onContinue
}: LeaveStepDialogProps) => {
  const unanswered = progress.required - progress.answered;
  return (
    <ConfirmDialog
      open={open}
      title={`Continue without finishing ${stepName}?`}
      message={
        `${stepName} has ${unanswered} required question${unanswered === 1 ? '' : 's'} left unanswered. ` +
        `You can continue to ${destinationName} now — your answers are saved automatically, ` +
        'so you can pick this back up anytime.'
      }
      cancelLabel="Stay and finish"
      confirmLabel="Continue Anyway"
      confirmColor="primary"
      onCancel={onStay}
      onConfirm={onContinue}>
      <TextBlock
        size="sm14"
        color="grey6"
        className="mt-3">
        {`${progress.answered} of ${progress.required} required questions answered in this step`}
      </TextBlock>
    </ConfirmDialog>
  );
};

// A step with no counts yet has nothing required to finish.
export const hasUnansweredRequired = (progress?: StepProgress): progress is StepProgress =>
  !!progress && progress.answered < progress.required;
